import './polyfills/polyfills.js';

import 'bootstrap';
import * as AOS from 'aos';

// Theme Objects
import './themeObjects/searchbar.ts';
import './themeObjects/breadcrumbs.ts';
import './themeObjects/cookies.ts';
import './themeObjects/cart.ts';
import './themeObjects/guestCheckout.ts';

// Modules
import './modules/Cantarus/twitter-feed.ts';
import './modules/Cantarus/dispatch.ts';
import './modules/Silverbear/silverbear-events.ts';

// Components
import './components/sliders/carousel-slider.ts';
import './components/sliders/article-slider.ts';

declare var window: any;

$(function () {
    AOS.init();

    $(document).on('click', '[toggle-class]', (e) => {
        e.preventDefault();
        $(e.currentTarget.getAttribute('toggle-class-target')).toggleClass(e.currentTarget.getAttribute('toggle-class'));
    })

    $("[data-toggle='fade']").on('click', function () {
        var button = $(this);
        var target = $(button.attr('data-target'));

        if (!target.length) {
            console.debug("No target for toggle-fade");
            return;
        }

        if (!target.hasClass('fader')) {
            target.addClass('fader');
        }

        if (!target.hasClass('fading')) {
            target.addClass('fading');
            setTimeout(() => {
                target.addClass('show');
            }, 10);
        } else {
            target.removeClass('show');
            setTimeout(() => {
                target.removeClass('fading');
            }, 400);
        }
    });
});

// Mega-menu-mobile

class MegaMenu {
    wrapper: HTMLElement
    currentNavItem: HTMLLIElement;
    depth: number;
    backButton: HTMLButtonElement;
    navbar: HTMLElement;

    constructor(wrapper: HTMLElement) {
        this.wrapper = wrapper;
        this.depth = 0;
        this.navbar = $(wrapper).closest('.navbar')[0];

        wrapper.querySelectorAll('ol.cantarus-megamenu > li > a').forEach((a) => {
            let li = a.parentElement;
            if (li.classList.contains('has-submenu')) {
                $(li).hoverIntent({
                    over: (e: MouseEvent) => {
                        if (window.innerWidth < 992) {
                            return;
                        }
                        e.preventDefault();
                        let el = (e.currentTarget as HTMLElement) as HTMLLIElement;
                        this.showNavItem(el);
                    },
                    out: (e: MouseEvent) => {
                        if (window.innerWidth < 992) {
                            return;
                        }
                        e.preventDefault();
                        if (e.currentTarget === this.currentNavItem) {
                            this.hideNavItem();
                        }
                    },
                    timeout: 400
                });

                let arrow = li.querySelector('span');
                if (arrow) {
                    arrow.addEventListener('click', (e) => {
                        if (window.innerWidth >= 992) {
                            return;
                        }
                        e.preventDefault();
                        let el = (e.currentTarget as HTMLElement).parentElement as HTMLLIElement;
                        this.showNavItem(el);
                    });
                }
                li.querySelectorAll('[data-show-menuid]').forEach(item => {
                    item.addEventListener('mouseover', (e: MouseEvent) => {
                        if (window.innerWidth >= 992) {
                            e.preventDefault();
                            let el = (e.currentTarget as HTMLLIElement);
                            this.subMenu_click(el);
                        }
                    });
                    let arrow = item.querySelector('span');
                    if (arrow) {
                        arrow.addEventListener('click', (e) => {
                            e.preventDefault();
                            let el = (e.currentTarget as HTMLLIElement).parentElement;
                            this.subMenu_click(el);
                        });
                    }
                })
            }
        });

        this.backButton = wrapper.querySelector('.menu-button-back') as HTMLButtonElement;

        if (this.backButton) {
            this.backButton.style.visibility = 'hidden';
            this.backButton.addEventListener('click', (e) => {
                e.preventDefault();
                if (this.depth > 1) {
                    this.hideAllSubNavs();
                } else {
                    if (this.depth > 0) {
                        this.hideNavItem();
                    } else {
                    }
                }
            })
        }
    }

    subMenu_click(el: HTMLElement) {
        let menuId = el.dataset.showMenuid;
        this.showSubNav(menuId);
        el.classList.add('selected');
    }

    showNavItem(navitem: HTMLLIElement) {
        if (this.currentNavItem) {
            this.hideNavItem();
        }

        navitem.classList.add('selected');

        //this.wrapper.querySelectorAll('.show').forEach(item => { item.classList.remove('show') });

        let megamenu = navitem.querySelector('.megamenu');

        megamenu.classList.add('fading');
        setTimeout(() => {
            megamenu.classList.add('show');
        }, 10);
        this.currentNavItem = navitem;
        this.depth = 1;
        this.wrapper.dataset['depth'] = this.depth.toString();
        if (this.navbar) {
            this.navbar.classList.add('megamenu-visible');
        }
        if (this.backButton) {
            this.backButton.style.visibility = 'visible';
        }
    }

    hideNavItem() {
        if (this.currentNavItem) {
            let megamenu = this.currentNavItem.querySelector('.megamenu');
            megamenu.classList.remove('show');
            setTimeout(() => {
                megamenu.classList.remove('fading');
            }, 400);
            this.currentNavItem.querySelectorAll('.selected').forEach(item => {
                item.classList.remove('selected');
            });
            this.currentNavItem.classList.remove('selected');
            this.currentNavItem = null;
            this.depth = 0;
            this.wrapper.dataset['depth'] = this.depth.toString();
            if (this.navbar) {
                this.navbar.classList.remove('megamenu-visible');
            }
            if (this.backButton) {
                this.backButton.style.visibility = 'hidden';
            }
        }
    }

    showSubNav(index: number | string) {
        if (!this.currentNavItem) {
            console.error('No nav currently open');
            return;
        }

        let subnav = this.currentNavItem.querySelectorAll('[data-menuid="' + index + '"]');
        if (!(subnav && subnav.length)) {
            console.error('request to select ivnvalid subnav ' + index, subnav);
            return;
        }
        this.hideAllSubNavs();

        subnav[0].classList.add('fading');
        setTimeout(() => {
            subnav[0].classList.add('show');
        }, 10);
        this.depth = 2;
        this.wrapper.dataset['depth'] = this.depth.toString();
    }

    hideAllSubNavs() {
        this.currentNavItem.querySelectorAll('[data-menuid].show').forEach(item => {
            item.classList.remove('show');
            item.classList.remove('fading');
        });;
        this.currentNavItem.querySelectorAll('.selected').forEach(item => {
            item.classList.remove('selected');
        });
        this.depth = 1;
        this.wrapper.dataset['depth'] = this.depth.toString();
    }
}

window['megaMenus'] = [];

$(function () {
    document.querySelectorAll('.mega-menu').forEach(menu => {
        window['megaMenus'].push(new MegaMenu(menu as HTMLElement));
    })
});

$(".ModAuthenticationC a[id$=Login_Login_Membership_passwordLink]").attr('onclick', '').attr('href', '/Site-Access/Password-Reset');
